import React, { useState } from 'react';
import axios from 'axios';

import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import type { OrganizationModel } from '~/components/types/organization-types';
import Switch from '~/components/ui/atoms/Switch';
import type { FnolOrganizationConfigurationModel } from '~/server_shared/openapi/data-contracts';
import { reportAxiosError } from '~/Utils';

interface SysconfigOrganizationContext {
  organization: OrganizationModel;
  reloadOrganization: () => Promise<void> | void;
}

const FnolMandatoryFieldsAsteriskSwitch: React.FC = () => {
  const { organization, reloadOrganization } = useSysconfig() as SysconfigOrganizationContext;
  const [isSaving, setIsSaving] = useState(false);
  const checked = Boolean(organization.configuration?.fnol_configuration?.show_asterisk_on_mandatory_fields);

  const handleChange = async (_event: unknown, newChecked: boolean) => {
    setIsSaving(true);
    try {
      const body: FnolOrganizationConfigurationModel = { show_asterisk_on_mandatory_fields: newChecked };
      await axios.put(`/sysconfig/api/v1/organizations/${organization.id}/fnol_configuration`, body);
      await reloadOrganization();
    } catch (error) {
      // The switch keeps showing the stored value, which the failed save did not change.
      reportAxiosError(error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="mb-8">
      <Switch
        checked={checked}
        disabled={isSaving}
        onChange={handleChange}
        label="Show an asterisk on mandatory FNOL fields"
      />
    </div>
  );
};

export default FnolMandatoryFieldsAsteriskSwitch;
